module.exports = __webpack_public_path__ + "img/flot4.8be40fc8.svg";